import React, { useEffect, useState } from 'react';
import { Switch, Route, useLocation, Redirect } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import Login from './views/auth/login/Login';
import LinkedProfile from './views/auth/LinkedProfile';
import NotFound from './views/static/NotFound';
import Register from './views/auth/register/Register';
import * as routes from './constants/routes';
import './translations/i18n';
import PasswordReset from './views/auth/passwordReset/PasswordReset';
import Home from './views/home/Home';
import { getToken } from './helpers';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProfile } from './reducers/profile/profile.actions';
import { fetchCreditCards, getCurrentUser, getNotifications } from './reducers/auth/auth.actions';
import { selectAuthUser, selectCreditCards, selectIsAuthorizing } from './reducers/auth/auth.selectors';
import Notifications from './views/notifications/Notifications';
import AddPost from './views/addPost/AddPost';
import Profile from './views/profile/Profile';
import Messages from './views/messages/Messages';
import Settings from './views/profile/settings/Settings';
import Contacts from './views/profile/settings/contact/contact';
import Payments from './views/profile/settings/financial/WidgetPayment/WidgetPayment';
import AddCard from './views/profile/settings/financial/AddCard';
import chatService from './chatService';
import { setChatTokenActionCreator } from './reducers/auth/auth.actionCreators';
import API from './API';
import Lists from './views/lists/Lists';
import { setChatUnreadCountActionCreator } from './reducers/notifications/notifications.actionCreators';
import { MESSAGES } from './constants/routes';
import SinglePost from './views/SinglePost';
import Dashboard from './views/admin/Dashboard';
import AdminLayout from './views/admin/AdminLayout';
import Reports from './views/admin/Reports';
import SubscribeList from './views/lists/SubscribeList';
import Terms from './views/static/Terms';
import Privacy from './views/static/Privacy';
import TermsAndPrivacy from './views/profile/settings/termsAndPrivacy/TermsAndPrivacy';
import MenuSettings from './views/profile/settings/MenuSettings';
import { Trans, useTranslation } from 'react-i18next';
import PublicRoute from './components/PublicRoute';
import './styles/sass/app.scss';
import NewPasswordScreen from 'views/auth/passwordReset/NewPasswordScreen';
import ChooseArtwork from 'views/profile/settings/profile/ChooseArtwork';
import ErrorBoundary from 'ErrorBoundary';
import Bookmarks from './views/profile/Bookmarks';
import Search from 'views/search/Search';
import SavedPost from 'views/savedPost/SavedPost';
import EditPost from 'views/editPost/EditPost';
import SendMessage from 'views/messages/SendMessage';
import AccountSupport from 'views/profile/settings/helpsupport/AccountSupport';
import AccountSecurity from 'views/profile/settings/helpsupport/AccountSecurity';
import GeneralQuestions from 'views/profile/settings/helpsupport/GeneralQuestions';
import PrivacyTermsSupport from 'views/profile/settings/helpsupport/PrivacyTermsSupport';
import QuestionSupport from 'views/profile/settings/HelpSupportInner';
import SearchSupport from 'views/profile/settings/HelpSearch';
import SubscriptionsFaq from 'views/profile/settings/helpsupport/SubscriptionsFaq';
import PaymentFaq from 'views/profile/settings/helpsupport/PaymentFaq';
import TipsFaq from 'views/profile/settings/helpsupport/TipsFaq';
import MyWalletFaq from 'views/profile/settings/helpsupport/MyWalletFaq';
import ValueTaxFaq from 'views/profile/settings/helpsupport/ValueTaxFaq';
import BecomeCreatorFaq from 'views/profile/settings/helpsupport/BecomeCreatorFaq';
import EarningsPayoutsFaq from 'views/profile/settings/helpsupport/EarningsPayoutsFaq';
import CreatorTipsFaq from 'views/profile/settings/helpsupport/CreatorTipsFaq';
import AccountFaq from 'views/profile/settings/helpsupport/AccountFaq';
import AccountSettingsFaq from 'views/profile/settings/helpsupport/AccountSettingsFaq';
import TaggingFaq from 'views/profile/settings/helpsupport/TaggingFaq';
import PromotiongFaq from 'views/profile/settings/helpsupport/PromotiongFaq';
import ReferralsFaq from 'views/profile/settings/helpsupport/ReferralsFaq';
import TechnicalFaq from 'views/profile/settings/helpsupport/TechnicalFaq';
import CreatorValueTaxFaq from 'views/profile/settings/helpsupport/CreatorValueTaxFaq';
import TaxInfoFaq from 'views/profile/settings/helpsupport/AccountSupport';
import firebase from 'firebase';
import firebaseService from 'firebaseService';
import EmailExpired from 'views/email_expired/EmailExpired';
import AddPaymentModal from 'components/AddPaymentModal';
import moment from 'moment';
import ScrollToTop from 'components/ScrollToTop';
import Channels from 'views/profile/settings/channels/Channels';
import Members from 'views/profile/settings/members/Members';
import AddBank from 'views/profile/settings/financial/AddBank';
import AddBankForm from 'views/profile/settings/financial/AddBankForm';
import RegisteredBank from 'views/profile/settings/financial/RegisteredBank';


const App = props => {
  moment.locale(localStorage.current_language)
  const { t, i18n } = useTranslation();
  const user = useSelector(selectAuthUser);
  const [notify, setNotify] = useState(null);
  const isLoading = useSelector(selectIsAuthorizing);
  const creditCards = useSelector(selectCreditCards);
  const location = useLocation();
  const dispatch = useDispatch();
  const token = getToken();
  const [openTipModal, setOpenTipModal] = useState(false);
  const [notifyUser, setNotifyUser] = useState(null);
  const [isSubArray, setSubArray] = useState(null);

  const notificationMethod = () => {

    dispatch(getNotifications()).then(
      (resp) => {
        if (resp) {
          let subArray = [];
          resp.data.reverse().slice().map((item) => {
            if (item.type.includes('SubscriptionChanged') && item.read_at === null) {
              subArray.push(item)
              setNotify(item)

              dispatch(fetchProfile(item.data.vendorUser.id))
                .then(resp => {
                  setNotifyUser(resp)
                  setOpenTipModal(true)
                })
                .catch(err => {
                  console.log('fetch post error', err);
                })



            }



          })
          setSubArray(subArray)


        }
      })
  }
  useEffect(() => {
    if (token && !user && !isLoading) {
      //get token user data
      dispatch(getCurrentUser());

    }

    if (token && token.length > 0) { notificationMethod() }

    if (!localStorage.getItem('current_language')) {
      localStorage.setItem('current_language', 'en')
    }

    if (user && !chatService.initialized) {

      if (!firebase.apps.length) {
        firebaseService.init();
      }
    }
  }, [user]);

  const initCHat = chatToken => {
    chatService.init(chatToken).then(resp => {
      //set chat token after chat and client is initialized
      if (resp) {
        dispatch(setChatTokenActionCreator(chatToken));
        if (location.pathname !== MESSAGES) {
          chatService.getUnreadMessageCount().then(resp => {
            if (Object.keys(resp).length > 0) {
              //unreadMessageCount, show notificaiton
              dispatch(setChatUnreadCountActionCreator(1));
            }
          });
        }
      }
    });
  };

  useEffect(() => {
    let currentLanguge = localStorage.getItem('current_language');
    if (currentLanguge === 'he') {
      document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
    }
  }, [])
  return (
    <ErrorBoundary>
      <Trans  >
        <ScrollToTop />

        <Switch>
          <Route exact path={routes.REGISTER} component={Register} />
          <Route exact path={routes.LOGIN} component={Login} />
          <Route exact path={routes.PASSWORD_RESET} component={PasswordReset} />
          <Route exact path={routes.NEW_PASSWORD} component={NewPasswordScreen} />
          <Route exact path={routes.TERMS} component={Terms} />
          <Route exact path={routes.PRIVACY} component={Privacy} />
          <Route exact path="/u/">
            <Redirect to={routes.LOGIN} />
          </Route>
          {
            token == null ?
              <Route title={t('User Profilessss')} exact strict path={routes.USER_PROFILE} component={LinkedProfile} />

              :
              <PrivateRoute title={t('User Profile')} exact path={routes.USER_PROFILE} component={Profile} />

          }
          <PrivateRoute exact path={routes.SEARCH} component={Search} />
          <PrivateRoute exact title={t('')} path={routes.ROOT} component={Home} />
          <PrivateRoute exact title={t('Notifications')} path={routes.NOTIFICATIONS} component={Notifications} />
          <PrivateRoute exact title={t('Create Post')} path={routes.ADD_POST} component={AddPost} />
          <PrivateRoute exact title={t('Edit Post')} path={routes.EDIT_POST} component={EditPost} />
          <PrivateRoute exact title={t('Profile')} path={routes.PROFILE} header={false} component={Profile} />
          {/* <PublicRoute exact path={routes.USER_PROFILE} component={Profile} /> */}
          <PublicRoute exact path={routes.CHOOSE_ARTWORK} component={ChooseArtwork} />

          <PrivateRoute title={t('Terms And Privacy')} exact path={routes.TERMS_PRIVACY} component={TermsAndPrivacy} />
          <PrivateRoute
            title={t('Settings')}
            exact
            path={[
              routes.MENUSETTINGS,

            ]}
            component={MenuSettings}
          />
          <PrivateRoute title={t('Account')} exact path={routes.ACCOUNT_SUPPORT} component={AccountSupport} />
          <PrivateRoute title={t('Questions')} exact path={routes.QUESTION_SUPPORT} component={QuestionSupport} />
          <PrivateRoute title={t('Search')} exact path={routes.SEARCH_SUPPORT} component={SearchSupport} />
          <PrivateRoute
            title={t('Account Security')}
            exact
            path={routes.ACCOUNT_SECURITY_SUPPORT}
            component={AccountSecurity}
          />
          <PrivateRoute
            title={t('General Questions')}
            exact
            path={routes.GENERAL_QUESTIONS_SUPPORT}
            component={GeneralQuestions}
          />
          <PrivateRoute
            title={t('Privacy Center and Terms')}
            exact
            path={routes.PRIVACY_TERMS_SUPPORT}
            component={PrivacyTermsSupport}
          />
          <PrivateRoute title={t('members')} exact path={routes.MEMBERS} component={Members}/>
          <PrivateRoute title={t('channels')} exact path={routes.CHANNELS} component={Channels}/>
          <PrivateRoute title={t('Subscriptions')} exact path={routes.SUBSCRIPTION_FAQ} component={SubscriptionsFaq} />
          <PrivateRoute title={t('Payment')} exact path={routes.PAYMENT_FAQ} component={PaymentFaq} />
          <PrivateRoute title={t('Tips')} exact path={routes.TIPS_FAQ} component={TipsFaq} />
          <PrivateRoute title={t('My Wallet')} exact path={routes.MY_WALLET_FAQ} component={MyWalletFaq} />
          <PrivateRoute title={t('Value Added Tax')} exact path={routes.VALUE_TAX_FAQ} component={ValueTaxFaq} />
          <PrivateRoute title={t('Bookmarks')} exact path={routes.BOOKMARKS} component={Bookmarks} />
          <PrivateRoute
            title={t('Can I become a Creator from my Country')}
            exact
            path={routes.BECOME_CREATOR_SUPPORT}
            component={BecomeCreatorFaq}
          />
          <PrivateRoute
            title={t('Earnings and Payouts')}
            exact
            path={routes.CREATOR_ERNING_PAYOUTS_SUPPORT}
            component={EarningsPayoutsFaq}
          />
          <PrivateRoute title={t('Tips')} exact path={routes.CREATOR_TIPS_SUPPORT} component={CreatorTipsFaq} />
          <PrivateRoute title={t('Account')} exact path={routes.CREATOR_ACC_SUPPORT} component={AccountFaq} />
          <PrivateRoute
            title={t('Account and Page Settings')}
            exact
            path={routes.CREATOR_ACC_SET_SUPPORT}
            component={AccountSettingsFaq}
          />
          <PrivateRoute title={t('Tagging')} exact path={routes.CREATOR_TAG_SUPPORT} component={TaggingFaq} />
          <PrivateRoute
            title={t('Promoting Your ShowIt Account')}
            exact
            path={routes.CREATOR_PROMOTING_SUPPORT}
            component={PromotiongFaq}
          />
          <PrivateRoute title={t('Referrals')} exact path={routes.CREATOR_REF_SUPPORT} component={ReferralsFaq} />
          <PrivateRoute
            title={t('Technical Questions')}
            exact
            path={routes.CREATOR_TECH_SUPPORT}
            component={TechnicalFaq}
          />
          <PrivateRoute
            title={t('Value Added Tax')}
            exact
            path={routes.CREATOR_VALUE_SUPPORT}
            component={CreatorValueTaxFaq}
          />
          <PrivateRoute title={t('Tax Information')} exact path={routes.CREATOR_TAX_INF_SUPPORT} component={TaxInfoFaq} />
          <PrivateRoute title={t('Payments')} exact path={routes.PAYMENTS} component={Payments} />

          <PrivateRoute title={t('Saved posts')} path={routes.SAVED_POSTS} component={SavedPost} />
          <PrivateRoute title={t('Lists')} path={routes.LISTS} component={Lists} />
          <PrivateRoute title={t('Subscribers')} exact path={routes.SUBSCRIBERS} component={SubscribeList} />
          <PrivateRoute title={t('Subscriptions')} exact path={routes.SUBSCRIPTIONS} component={SubscribeList} />
          <PrivateRoute title={t('Liked Posts')} exact path={routes.LIKEDPOSTS} component={Home} showTotal={true} />
          <PrivateRoute title={t('Purchased Posts')} path={routes.PURCHASEDPOSTS} component={Home} showTotal={true} />
          <PrivateRoute
            title={t('Settings')}
            exact
            path={[
              routes.SETTINGS,
              routes.SETTINGS_PROFILE,
              routes.SETTINGS_ACCOUNT,
              routes.SETTINGS_FINANCIAL,
              routes.HELP_SUPPORT,
            ]}
            component={Settings}
          />
          <PrivateRoute title={t('Add Card')} exact path={routes.ADD_CARD} component={AddCard} />
          <PrivateRoute title={t('Bank account')} exact path={routes.BANK_ACCOUNT} component={AddBank} />
          <PrivateRoute title={t('Bank account')} exact path={routes.ADD_BANK} component={AddBankForm} />
          
          <PrivateRoute title={t('Contact Us')} exact path={routes.CONTACT_US} component={Contacts} />
          <PrivateRoute title={t('Messages')} exact path={routes.MESSAGES} component={Messages} />
          <PrivateRoute title={t('Send a message')} exact path={routes.SEND_MESSAGE} component={SendMessage} />
          <PrivateRoute title={t('Email expired')} exact path={routes.EMAIL_EXPIRED} component={EmailExpired} />

          <PrivateRoute title={t('Post')} exact path={routes.SINGLE_POST} component={SinglePost} user={user} />
          <PrivateRoute
            title={t('Admin')}
            path={routes.ADMIN}
            exact
            allowedRole={5}
            layout={AdminLayout}
            component={Dashboard}
          />
          <PrivateRoute
            title={t('Reports')}
            exact
            path={routes.ADMIN_REPORTS}
            allowedRole={5}
            layout={AdminLayout}
            component={Reports}
          />
          <Route component={NotFound} />

        </Switch>

      </Trans>
      {openTipModal && (
        <AddPaymentModal notify={notify} notificationMethod={notificationMethod} isSubArray={isSubArray} userDate={notifyUser} notifyUser={notifyUser.user} show={openTipModal} onHide={() => setOpenTipModal(false)} />
      )}

    </ErrorBoundary>
  );
};

export default App;
